import { render } from "./2025_FONPAT_Talleres.vue?vue&type=template&id=5e3dbc20&scoped=true"
import script from "./2025_FONPAT_Talleres.vue?vue&type=script&lang=js"
export * from "./2025_FONPAT_Talleres.vue?vue&type=script&lang=js"

import "./2025_FONPAT_Talleres.vue?vue&type=style&index=0&id=5e3dbc20&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3dbc20"]])

export default __exports__